import React, { Component } from 'react';

import PaginationComponent from '../components/PaginationComponent';
import ModalPurchase from '../components/ModalPurchase';
import { TICKET_STATUS, TICKET_PAYMENT_METHOD, TICKET_INVOICE_STATUS, isAdmin, selectablePaymentMethods } from '../utils/enums';
import { sortClass, nextSortDir, sortAriaSort } from '../utils/table';
import { convertToMoney, getTextColorClassTicket } from '../utils/formats';
import dateFormat from 'dateformat';
import { buildPaginationQuery, getPaginatedData, scheduleDebouncedCallback, clearDebouncedCallback } from '../utils/pagination';
import { hasActiveSearch, getSearchEmptyMessage } from '../utils/tableState';
import { getPosDevices } from '../utils/reservationsApi';
import { cuerpoDelCobro, ofreceElegirMedio } from '../utils/cobroPendiente';
import CobroPendienteFields from './CobroPendienteFields';

var config = process.env;

// «Incluido en evento» (TICKET_PAYMENT_METHOD[7]): el medio de una comanda incluida en un evento.
const INCLUDED_PAYMENT_METHOD = 7;

class TableTicketComponent extends Component {

    constructor() {
        super();
        this.state = {
            purchaseId: 0,
            quantityShowRows: 25,
            currentPage: 1,
            totalItems: 0,
            search: '',
            searchInput: '',
            sortBy: 'ticketId',
            sortDir: 'desc',
            data: [],
            loaded: false,
            selectedTickets: [],
            posDevices: []
        };
        // Lo elegido en "¿Con qué pagó?" de cada modal, por ticketId. Campo de instancia y no
        // estado: se lee recién al confirmar, como el resto del modal (por id del DOM).
        this.cobros = {};
    }

    componentDidMount() {
        this.fetchData();
        // Una sola vez para toda la grilla: hay un modal por fila.
        getPosDevices()
            .then((devices) => this.setState({ posDevices: Array.isArray(devices) ? devices : [] }))
            .catch(() => {});
    }

    componentWillUnmount() {
        clearDebouncedCallback(this, 'searchDebounceTimeout');
    }

    componentDidUpdate(prevProps) {
        if (prevProps.mode !== this.props.mode) {
            this.setState({ selectedTickets: [] }, this.notifySelection);
            this.fetchData({ page: 1 });
        }
    }

    fetchData = ({
        page = this.state.currentPage,
        limit = this.state.quantityShowRows,
        search = this.state.search,
        sortBy = this.state.sortBy,
        sortDir = this.state.sortDir,
        showLoader = true,
    } = {}) => {
        if (showLoader) {
            this.setState({ loaded: false });
        }
        var request = {
            method: 'GET',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            }
        };
        const query = buildPaginationQuery({
            page,
            limit,
            search,
            sortBy,
            sortDir,
            extraParams: {
                invoiceStatus: this.props.mode === 1 ? 0 : undefined,
            },
        });
        fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}ticket?${query}`, request)
        .then(results => results.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                if (data.error == 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
            } else {
                const paginatedData = getPaginatedData(data);
                this.setState({
                    data: paginatedData.items || [],
                    quantityShowRows: paginatedData.limit || Number(limit),
                    currentPage: paginatedData.page || Number(page),
                    totalItems: paginatedData.total || 0,
                    search,
                    sortBy,
                    sortDir,
                    loaded: true
                });
            }
        });
    }

    renderEmptyState = () => {
        return (
            <div
                style={{
                    background: '#ffffff',
                    borderRadius: '0.625rem',
                    boxShadow: '0 .125rem .625rem rgba(90,97,105,.12)',
                    border: '1px solid #e1e5eb',
                    minHeight: '320px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2rem',
                }}
            >
                <div style={{ textAlign: 'center', maxWidth: '420px' }}>
                    <div
                        style={{
                            width: '72px',
                            height: '72px',
                            margin: '0 auto 1rem',
                            borderRadius: '50%',
                            background: '#f5f6f8',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <i className="material-icons" style={{ fontSize: '34px', color: '#818ea3' }}>receipt_long</i>
                    </div>
                    <h4 style={{ marginBottom: '0.75rem', color: '#3d5170', fontWeight: 500 }}>
                        Todavia no hay tickets para mostrar
                    </h4>
                    <p style={{ margin: 0, color: '#818ea3', lineHeight: 1.6 }}>
                        Cuando se generen tickets, aca vas a ver el historial con su estado,
                        metodo de pago, factura y accesos rapidos.
                    </p>
                </div>
            </div>
        );
    }

    renderLoader = () => {
        return (
            <div
                style={{
                    background: '#ffffff',
                    borderRadius: '0.625rem',
                    boxShadow: '0 .125rem .625rem rgba(90,97,105,.12)',
                    border: '1px solid #e1e5eb',
                    minHeight: '320px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2rem',
                }}
            >
                <div className="containerLoader" style={{ display: 'block', position: 'static', width: '100%' }}>
                    <div className="loader"></div>
                </div>
            </div>
        );
    }

    handleCheckboxChange = (id) => {
        this.setState((prevState) => {
            const selectedTickets = prevState.selectedTickets.includes(id)
                ? prevState.selectedTickets.filter(item => item !== id)
                : [...prevState.selectedTickets, id];

            return { selectedTickets };
        }, this.notifySelection);
    };

    // Los ids de la página que se está viendo. La grilla pagina y filtra en el server, asi que
    // `data` YA es el resultado del filtro (búsqueda + `invoiceStatus=0` en modo selección): el
    // "seleccionar todo" de la cabecera no necesita saber nada del filtro, alcanza con tomar lo
    // que la página tiene a la vista.
    pageTicketIds = () => this.state.data.map(item => item.ticketId);

    // Cuántos de los de esta página están tildados. La selección sobrevive al cambio de página,
    // así que el estado de la cabecera se mide SÓLO contra la página actual.
    pageSelectionCount = () => {
        const selected = this.state.selectedTickets;
        return this.pageTicketIds().filter(id => selected.includes(id)).length;
    }

    handleSelectAllChange = () => {
        this.setState((prevState) => {
            const pageIds = prevState.data.map(item => item.ticketId);
            const allSelected = pageIds.length > 0 && pageIds.every(id => prevState.selectedTickets.includes(id));

            const selectedTickets = allSelected
                ? prevState.selectedTickets.filter(id => !pageIds.includes(id))
                : [...prevState.selectedTickets, ...pageIds.filter(id => !prevState.selectedTickets.includes(id))];

            return { selectedTickets };
        }, this.notifySelection);
    };

    notifySelection = () => {
        const totalSum = this.state.data
            .filter(item => this.state.selectedTickets.includes(item.ticketId))
            .reduce((sum, item) => sum + item.totalPrice, 0);

        if (typeof this.props.setSelectedTicketsAmmount === 'function') {
            this.props.setSelectedTicketsAmmount(totalSum);
        }
        if (typeof this.props.setSelectedTicketsCount === 'function') {
            this.props.setSelectedTicketsCount(this.state.selectedTickets.length);
        }
    }

    loadData = () => {
        if (!this.state.loaded) {
            return <tbody></tbody>;
        }

        const items = this.state.data.map((item, index) => this.drawRow(item, index));
        if (items.length === 0) {
            items.push(
                <tr key="empty">
                    <td colSpan={this.props.mode >= 1 ? 9 : 8} style={{ textAlign: 'center', padding: '10px', border: '1px solid rgb(225, 229, 235)' }}>
                        {getSearchEmptyMessage(this.state.searchInput || this.state.search)}
                    </td>
                </tr>
            );
        }
        return <tbody>{items}</tbody>;
    }

    createModals = () => {
        if (!this.state.loaded) {
            return null;
        }

        return (
            <div>
                {this.state.data.map((data) => (
                    <React.Fragment key={data.ticketId}>
                        {this.createModalChangeTrack(data.ticketId, data.status, data.paymentType)}
                        {this.createModalInitialPoint(data.ticketId, data.paymentData)}
                    </React.Fragment>
                ))}
            </div>
        );
    }

    // El admin puede abrir CUALQUIER ticket: una venta ya cobrada o ya cancelada es justo la que
    // hay que corregir, y además es el único que puede tocar el metodo de pago. Para el resto
    // queda la regla de siempre: sólo un ticket pendiente de pago.
    canEdit = (status) => {
        return isAdmin(this.props.role) || (status != 2 && status != 9);
    }

    // "Cancelado" (9) NO se ofrece como opción, en ninguna de las dos direcciones: cancelar una
    // venta devuelve el stock, reintegra el crédito en tienda y libera el cupón, y eso lo hace el
    // botón "Cancelar venta" del detalle. Un ticket cancelado se abre con el estado bloqueado.
    getItemsTicket = (currentStatus) => {
        if (currentStatus == 9) {
            return [];
        }
        return [2, 3].map((status) => (
            <option value={status} key={status}>{TICKET_STATUS[status]}</option>
        ));
    }

    // El ticket de una comanda incluida en un evento (medio 7) no se edita, ni el estado ni el
    // medio: el backend rechaza cualquier cambio con 7605. Lo incluido se corrige anulando la venta.
    isIncludedTicket = (paymentType) => Number(paymentType) === INCLUDED_PAYMENT_METHOD;

    createModalChangeTrack = (ticketId, currentStatus, currentPaymentType) => {
        const admin = isAdmin(this.props.role);
        const cancelled = currentStatus == 9;
        const included = this.isIncludedTicket(currentPaymentType);
        return (
            <div className="modal fade" id={`modal-${ticketId}`} role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title" style={{ textAlign: 'center' }}>
                                {admin ? 'Editar ticket' : 'Cambiar estado del ticket'}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <label htmlFor={`status-${ticketId}`}>Estado</label>
                            <select
                                id={`status-${ticketId}`}
                                className="custom-select"
                                defaultValue={currentStatus}
                                disabled={cancelled || included}>
                                {this.getItemsTicket(currentStatus)}
                            </select>
                            {cancelled ? (
                                <small className="text-muted d-block mt-1">
                                    La venta está cancelada. El estado no se reabre desde acá: el stock ya volvió
                                    al inventario y el crédito ya se reintegró.
                                </small>
                            ) : ''}
                            {included ? (
                                <div className="mt-3">
                                    <label className="d-block">Metodo de pago</label>
                                    {/* Como texto y no en el combo: el 7 no es una opción elegible, y
                                        un combo sin él arrancaría parado en «Efectivo». */}
                                    <p className="mb-1" id={`payment-text-${ticketId}`}>{TICKET_PAYMENT_METHOD[currentPaymentType]}</p>
                                    <small className="text-muted d-block">
                                        Un ticket incluido en un evento no se edita. Para corregirlo, anulá la venta.
                                    </small>
                                </div>
                            ) : admin ? (
                                <div className="mt-3">
                                    <label htmlFor={`payment-${ticketId}`}>Metodo de pago</label>
                                    <select
                                        id={`payment-${ticketId}`}
                                        className="custom-select"
                                        defaultValue={currentPaymentType == null ? '' : currentPaymentType}>
                                        {currentPaymentType == null ? (
                                            <option value="" key="none">— Sin definir —</option>
                                        ) : ''}
                                        {/* Sólo los medios ELEGIBLES: «Cuenta de empleado» se nombra en el
                                            mapa —la grilla lo muestra— pero no se puede elegir acá. Moverle el
                                            medio a un ticket de la cuenta del equipo, o meterle uno, crearía o
                                            haría desaparecer una deuda que el libro no registró; el backend lo
                                            rechaza con 3607 y la UI no tiene por qué ofrecerlo (TC-017). */}
                                        {selectablePaymentMethods().map(([code, label]) => (
                                            <option value={code} key={code}>{label}</option>
                                        ))}
                                    </select>
                                    <small className="text-muted d-block mt-1">
                                        Corrige el dato del ticket; no mueve la caja. El movimiento ya quedó imputado
                                        a la cuenta del metodo anterior: si el arqueo del dia ya se hizo, ajustalo
                                        por Movimientos.
                                    </small>
                                </div>
                            ) : ofreceElegirMedio(currentStatus, currentPaymentType) ? (
                                // El rol 2 cobra un pendiente por PATCH /ticket/status: si lo pasa a
                                // Pago, dice con qué pagó (sólo viaja si el estado elegido es Pago).
                                // El admin no pasa por acá: tiene el combo de medio de arriba.
                                <CobroPendienteFields
                                    idPrefix={`cobro-${ticketId}`}
                                    defaultPaymentType={currentPaymentType}
                                    devices={this.state.posDevices}
                                    onChange={(cobro) => { this.cobros[ticketId] = cobro; }} />
                            ) : ''}
                        </div>
                        <div className="modal-footer">
                            <button
                                className="mb-2 mr-1 btn btn-outline-secondary btn-sm"
                                data-dismiss="modal">
                                Cancelar
                            </button>
                            <button
                                className="mb-2 mr-1 btn btn-primary btn-sm"
                                data-dismiss="modal"
                                disabled={included}
                                onClick={() => this.onUpdateItem(ticketId, currentStatus, currentPaymentType)}>
                                Actualizar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    createModalInitialPoint = () => {
        return null;
    }

    onUpdateItem = (ticketId, currentStatus, currentPaymentType) => {
        if (this.isIncludedTicket(currentPaymentType)) {
            return;
        }
        const admin = isAdmin(this.props.role);
        const cancelled = currentStatus == 9;

        let status;
        if (!cancelled) {
            const statusValue = document.getElementById('status-' + ticketId).value;
            if (statusValue !== '') {
                status = parseInt(statusValue);
            }
        }

        let paymentType;
        if (admin) {
            const paymentValue = document.getElementById('payment-' + ticketId).value;
            if (paymentValue !== '') {
                paymentType = parseInt(paymentValue);
            }
        }

        if (status === undefined && paymentType === undefined) {
            return;
        }

        // El admin edita por el endpoint de corrección (estado + metodo de pago, rol 1). El resto
        // sigue por el PATCH /ticket/status de siempre, que sólo mueve el estado y sólo sobre un
        // ticket pendiente de pago — y, si lo pasa a Pago, lleva con qué pagó (cuerpoDelCobro).
        const url = admin
            ? `${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}ticket/${ticketId}`
            : `${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}ticket/status`;
        const body = admin
            ? {
                ...(status !== undefined ? { status } : {}),
                ...(paymentType !== undefined ? { paymentType } : {}),
            }
            : cuerpoDelCobro({
                ticketId, status, currentStatus, currentPaymentType, cobro: this.cobros[ticketId],
            });
        var request = {
            method: 'PATCH',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        };
        fetch(url, request)
        .then(results => results.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                if (data.error == 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
            } else {
                this.fetchData();
            }
        });
    }

    onTicketClicked = (purchaseId) => {
        this.setState({ purchaseId: purchaseId });
    }

    generateButtonInitailPoint = (ticketId, paymentData, status) => {
        let json = null;
        try {
            json = JSON.parse(paymentData);
        } catch (error) {
            json = null;
        }

        if (json != null && json.initial_point != undefined) {
            return (
                <button
                    id={`button-initialpoint-${ticketId}`}
                    type="button"
                    disabled={status == 2 || status == 9}
                    className="btn btn-white"
                    onClick={() => window.open(json.initial_point, '_blank')}
                ><i className="material-icons">link</i></button>
            );
        }
        return null;
    }

    drawRow = (item, index) => {
        return (
            <tr role="row" className="odd" key={item.ticketId} style={{ background: index % 2 == 0 ? '#ffffff;' : '#fcfcfc' }}>
                {this.props.mode >= 1 ? (
                    <td>
                        <input
                            type="checkbox"
                            checked={this.state.selectedTickets.includes(item.ticketId)}
                            onChange={() => this.handleCheckboxChange(item.ticketId)}
                        />
                    </td>
                ) : '' }
                <td tabIndex="0" className="sorting_1">{item.ticketId}</td>
                <td tabIndex="0" className="sorting_1">{dateFormat(item.date, 'dS mmmm, yyyy')}</td>
                <td id={`item-status-${item.ticketId}`} className={getTextColorClassTicket(item.status)}>{TICKET_STATUS[item.status]}</td>
                <td data-toggle="modal" data-target="#modal-view" onClick={() => this.onTicketClicked(item.purchaseId)}><a href="#!" onClick={(event) => event.preventDefault()}> {item.purchaseId} </a></td>
                <td>$ {convertToMoney(item.totalPrice)}</td>
                <td>{TICKET_PAYMENT_METHOD[item.paymentType]}</td>
                <td>{TICKET_INVOICE_STATUS[item.invoiceStatus]}</td>
                <td>
                    <div className="btn-group btn-group-sm" role="group" aria-label="Table row actions">
                        <button
                            id={`button-status-${item.ticketId}`}
                            data-toggle="modal"
                            data-target={`#modal-${item.ticketId}`}
                            type="button"
                            disabled={!this.canEdit(item.status)}
                            className="btn btn-white"><i className="material-icons">edit</i>
                        </button>
                        {this.generateButtonInitailPoint(item.ticketId, item.paymentData, item.status)}
                    </div>
                </td>
            </tr>
        );
    }

    changeMasiveStatus = (status) => {
        var request = {
            method: 'POST',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                status: parseInt(status),
                tickets: this.state.selectedTickets
            })
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'ticket/invoice', request)
        .then(results => results.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                if (data.error == 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
            } else {
                this.setState({ selectedTickets: [] }, () => {
                    this.notifySelection();
                    this.fetchData();
                });
            }
        });
    }

    onChangeShowRows = () => {
        const itemSelected = Number(document.getElementById('select_rows').value);
        this.fetchData({ page: 1, limit: itemSelected });
    }

    onChangeInput = (search) => {
        this.setState({ searchInput: search });
        scheduleDebouncedCallback(this, 'searchDebounceTimeout', () => {
            this.fetchData({ page: 1, search, showLoader: false });
        });
    }

    orderData = (column) => {
        this.fetchData({
            page: 1,
            sortBy: column,
            sortDir: nextSortDir(column, this.state.sortBy, this.state.sortDir),
        });
    }

    // Props de una cabecera ordenable: la clase y el aria-sort se derivan del state, así que
    // sobreviven al remonte que provoca el loader.
    sortableHeader = (column) => ({
        onClick: () => this.orderData(column),
        className: sortClass(column, this.state.sortBy, this.state.sortDir),
        'aria-sort': sortAriaSort(column, this.state.sortBy, this.state.sortDir),
        tabIndex: '0',
    })

    render() {
        if (!this.state.loaded) {
            return (
                <div>
                    {this.renderLoader()}
                    {this.createModals()}
                    <ModalPurchase purchaseId={this.state.purchaseId} onRefresh={this.fetchData}/>
                </div>
            );
        }

        if (this.state.totalItems === 0 && !hasActiveSearch(this.state.searchInput, this.state.search)) {
            return (
                <div>
                    {this.renderEmptyState()}
                    {this.createModals()}
                    <ModalPurchase purchaseId={this.state.purchaseId} onRefresh={this.fetchData}/>
                </div>
            );
        }

        return (
            <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer">
                <div className="dataTables_length" id="DataTables_Table_0_length">
                    <label>Show
                    <select id="select_rows" name="DataTables_Table_0_length" aria-controls="DataTables_Table_0" value={this.state.quantityShowRows} onChange={() => this.onChangeShowRows()}>
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    entries</label>
                </div>
                <div id="DataTables_Table_0_filter" className="dataTables_filter">
                    <label>Search:
                    <input id="input_search" type="search" className="" placeholder="" aria-controls="DataTables_Table_0" value={this.state.searchInput} onChange={(e) => this.onChangeInput(e.target.value)}/>
                    </label>
                </div>

                <table className="transaction-history d-none dataTable no-footer dtr-inline" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                    <thead>
                        <tr role="row">
                            {/* La columna de checkboxes no ordena nada: sin la clase `sorting` para que no simule serlo. */}
                            {/* El "algunos tildados" del select-all no es un valor del checkbox: hay que
                                pisar `indeterminate` a mano sobre el nodo, y el ref inline lo re-aplica en
                                cada render (el loader desmonta la tabla entera). */}
                            {this.props.mode >= 1 ? (
                                <th aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '5%' }}>
                                    <input
                                        id="select_all_tickets"
                                        type="checkbox"
                                        title="Seleccionar todos los tickets de esta página"
                                        aria-label="Seleccionar todos los tickets de esta página"
                                        disabled={this.state.data.length === 0}
                                        checked={this.state.data.length > 0 && this.pageSelectionCount() === this.state.data.length}
                                        ref={(el) => {
                                            if (el) {
                                                const selected = this.pageSelectionCount();
                                                el.indeterminate = selected > 0 && selected < this.state.data.length;
                                            }
                                        }}
                                        onChange={this.handleSelectAllChange}
                                    />
                                </th>
                            ) : '' }
                            <th {...this.sortableHeader('ticketId')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>ID</th>
                            <th {...this.sortableHeader('date')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '15%' }}>Fecha</th>
                            <th {...this.sortableHeader('status')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '15%' }}>Estado</th>
                            <th {...this.sortableHeader('purchaseId')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>Compra</th>
                            <th {...this.sortableHeader('totalPrice')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '15%' }}>Precio</th>
                            <th {...this.sortableHeader('paymentType')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '15%' }}>Metodo de pago</th>
                            <th {...this.sortableHeader('invoiceStatus')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '15%' }}>Factura</th>
                            <th rowSpan="1" colSpan="1" style={{ width: '10%' }}>Acciones</th>
                        </tr>
                    </thead>
                    {this.loadData()}
                </table>

                {this.createModals()}

                <ModalPurchase purchaseId={this.state.purchaseId} onRefresh={this.fetchData}/>

                <PaginationComponent
                    totalItems={this.state.totalItems}
                    quantityRows={this.state.quantityShowRows}
                    currentPage={this.state.currentPage}
                    onPageChange={(page) => this.fetchData({ page })}
                />
            </div>
        );
    }
}

export default TableTicketComponent;
